<template>
  <div id="app">
    <router-view></router-view>
    <div class="toast-stack">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="alert"
        :class="t.type"
      >
        <span class="ico">
          <svg v-if="t.type === 'success'" viewBox="0 0 24 24"><path d="M22 11.1V12a10 10 0 1 1-5.9-9.1"/><path d="m22 4-10 10-3-3"/></svg>
          <svg v-else-if="t.type === 'danger'" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/></svg>
          <svg v-else-if="t.type === 'warning'" viewBox="0 0 24 24"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><path d="M12 9v4M12 17h.01"/></svg>
          <svg v-else viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
        </span>
        <div class="body">{{ t.msg }}</div>
        <button class="close" @click="removeToast(t.id)" v-hint="$t('hint_close')" :aria-label="$t('hint_close')">
          <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GVV',
  components: {
  },
  data() {
    return {
      toasts: [],
      toastSeq: 0,
    };
  },
  methods: {
    addToast(type, msg) {
      const id = ++this.toastSeq;
      this.toasts.push({ id, type, msg });
      setTimeout(() => this.removeToast(id), 4000);
    },
    removeToast(id) {
      const i = this.toasts.findIndex(t => t.id === id);
      if (i !== -1) this.toasts.splice(i, 1);
    },
  },
  mounted(){
    this.$root.$on('toast', ({ type, msg }) => this.addToast(type, msg));
  },
  beforeDestroy() {
    this.$root.$off('toast');
  },
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.toast-stack {
  position: fixed !important;
  top: 24px !important;
  bottom: auto !important;
  right: 24px !important;
  left: auto !important;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 340px;
  max-width: calc(100vw - 48px);
}
.toast-stack .alert {
  box-shadow: 0 8px 24px -4px rgba(0,0,0,0.18);
  animation: toast-in 0.22s cubic-bezier(0.2,0.7,0.2,1);
}
@keyframes toast-in {
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
